import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { PatchInterpolationMapRequest, PatchInterpolationMapResponse, PostInterpolationMapRequest, PostInterpolationMapResponse } from './types/TInterpolationMapServices';

const URL_Prefix = '/interpolation_map';

export const interpolationMapService = createApi({
    reducerPath: 'interpolationMapService',
    baseQuery: getBaseQuery,
    tagTypes: ['InterpolationMap'],
    endpoints: (builder) => ({
        postInterpolationMap: builder.mutation<PostInterpolationMapResponse, FormData>({
            query: (formData) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: formData,
                // Для FormData не устанавливаем Content-Type, браузер сделает это автоматически
                headers: {
                    // Явно не устанавливаем Content-Type, чтобы браузер установил multipart/form-data с boundary
                }
            }),
            invalidatesTags: ['InterpolationMap'],
        }),
        patchInterpolationMap: builder.mutation<PatchInterpolationMapResponse, PatchInterpolationMapRequest>({
            query: (formData) => ({
                url: `${URL_Prefix}/${formData.uuid}`,
                method: 'PATCH',
                body: formData,
            }),
            invalidatesTags: ['InterpolationMap'],
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    usePostInterpolationMapMutation,
    usePatchInterpolationMapMutation,
} = interpolationMapService;